import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const MilestoneTracker = ({ milestones, onUpdateMilestone, onApproveMilestone }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'text-success';
      case 'in-progress':
        return 'text-warning';
      case 'pending':
        return 'text-muted-foreground';
      default:
        return 'text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return 'CheckCircle2';
      case 'in-progress':
        return 'Clock';
      case 'pending':
        return 'Circle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="space-y-4">
      {milestones?.map((milestone, index) => (
        <div key={milestone?.id} className="relative">
          {index !== milestones?.length - 1 && (
            <div className="absolute left-5 top-12 bottom-0 w-0.5 bg-border" />
          )}
          
          <div className="flex gap-4">
            <div className={`w-10 h-10 rounded-full border-2 flex items-center justify-center flex-shrink-0 bg-card ${
              milestone?.status === 'completed' ? 'border-success' :
              milestone?.status === 'in-progress'? 'border-warning' : 'border-border'
            }`}>
              <Icon 
                name={getStatusIcon(milestone?.status)} 
                size={20}
                className={getStatusColor(milestone?.status)}
              />
            </div>

            <div className="flex-1 bg-card border border-border rounded-lg p-4">
              <div className="flex items-start justify-between gap-4 mb-3">
                <div className="flex-1">
                  <h4 className="font-semibold text-foreground mb-1">{milestone?.title}</h4>
                  <p className="text-sm text-muted-foreground">{milestone?.description}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-medium text-foreground">{milestone?.payment}</p>
                  <p className="text-xs text-muted-foreground">{milestone?.dueDate}</p>
                </div>
              </div>

              {milestone?.deliverables && milestone?.deliverables?.length > 0 && (
                <div className="space-y-2 mb-3">
                  <p className="text-xs font-medium text-muted-foreground">Teslim Edilecekler:</p>
                  {milestone?.deliverables?.map((deliverable) => (
                    <div key={deliverable?.id} className="flex items-center gap-2">
                      <Checkbox
                        checked={deliverable?.completed}
                        onChange={(e) => onUpdateMilestone(milestone?.id, deliverable?.id, e?.target?.checked)}
                        size="sm"
                      />
                      <span className={`text-sm ${deliverable?.completed ? 'line-through text-muted-foreground' : 'text-foreground'}`}>
                        {deliverable?.name}
                      </span>
                    </div>
                  ))}
                </div>
              )}

              {milestone?.status === 'in-progress' && (
                <div className="flex items-center gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="Upload"
                    iconPosition="left"
                  >
                    Dosya Yükle
                  </Button>
                  <Button
                    variant="default"
                    size="sm"
                    iconName="CheckCircle"
                    iconPosition="left"
                    onClick={() => onApproveMilestone(milestone?.id)}
                  >
                    Onayla
                  </Button>
                </div>
              )}

              {milestone?.status === 'completed' && (
                <div className="flex items-center gap-2 text-sm text-success">
                  <Icon name="CheckCircle2" size={16} />
                  <span>Tamamlandı - {milestone?.completedDate}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MilestoneTracker;